export default __webpack_public_path__ + "static/media/googlechrome_icon.db4c75ac.svg";